var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 47,
    viewBox: "0 0 219 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_29806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.16 39H13.44V31.58H8.4V39H1.68V18H8.4V25.42H13.44V18H20.16V39ZM37.4717 32.98L37.9757 38.636C36.5383 39.2147 34.765 39.504 32.6557 39.504C30.6583 39.504 29.0063 39.2893 27.6997 38.86C26.393 38.412 25.357 37.74 24.5917 36.844C23.8263 35.948 23.285 34.8093 22.9677 33.428C22.669 32.0467 22.5197 30.4133 22.5197 28.528C22.5197 26.6987 22.6597 25.1027 22.9397 23.74C23.2383 22.3587 23.761 21.2107 24.5077 20.296C25.2543 19.3627 26.2623 18.6627 27.5317 18.196C28.8197 17.7293 30.4437 17.496 32.4037 17.496C32.833 17.496 33.309 17.524 33.8317 17.58C34.373 17.6173 34.8957 17.6733 35.3997 17.748C35.9223 17.8227 36.4077 17.916 36.8557 18.028C37.3223 18.1213 37.6957 18.2333 37.9757 18.364L36.9677 23.516C35.4743 23.1987 34.1397 23.04 32.9637 23.04C31.7503 23.04 30.9103 23.152 30.4437 23.376C29.977 23.6 29.7437 24.048 29.7437 24.72V33.512C30.173 33.6053 30.6023 33.68 31.0317 33.736C31.4797 33.7733 31.937 33.792 32.4037 33.792C34.2703 33.792 35.9597 33.5213 37.4717 32.98ZM47.0367 39H40.3167V18H47.0367V39Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0986 33.12L53.3186 36.9L50.4626 34.044L54.2426 30.264L50.4626 26.484L53.3186 23.628L57.0986 27.408L60.8786 23.628L63.7346 26.484L59.9546 30.264L63.7346 34.044L60.8786 36.9L57.0986 33.12Z",
    fill: "#6AA4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.432 32.812V31.916H143.724V26.764H151.816V37.992C149.165 39 146.412 39.504 143.556 39.504C141.596 39.504 139.972 39.2707 138.684 38.804C137.415 38.3373 136.407 37.6467 135.66 36.732C134.913 35.7987 134.391 34.6507 134.092 33.288C133.812 31.9067 133.672 30.3013 133.672 28.472C133.672 26.5307 133.849 24.8693 134.204 23.488C134.559 22.088 135.147 20.9493 135.968 20.072C136.789 19.176 137.881 18.5227 139.244 18.112C140.607 17.7013 142.296 17.496 144.312 17.496C144.76 17.496 145.283 17.524 145.88 17.58C146.496 17.6173 147.112 17.6827 147.728 17.776C148.344 17.8507 148.923 17.944 149.464 18.056C150.024 18.1493 150.472 18.252 150.808 18.364L149.8 23.516C148.885 23.3667 148.017 23.2547 147.196 23.18C146.375 23.0867 145.609 23.04 144.9 23.04C143.425 23.04 142.389 23.152 141.792 23.376C141.195 23.6 140.896 24.048 140.896 24.72V34.24H143.108C143.929 34.24 144.517 34.156 144.872 33.988C145.245 33.8013 145.432 33.4093 145.432 32.812ZM160.6 35.668L159.844 39H152.76L158.192 18H168.58L174.012 39H166.928L166.144 35.668H160.6ZM163.568 24.44H163.204L161.832 30.32H164.912L163.568 24.44ZM181.893 28.808L181.501 39H174.473L175.761 18H184.525L187.129 28.696H187.381L189.985 18H198.777L200.037 39H193.009L192.617 28.808H192.393L189.817 39H184.693L182.089 28.808H181.893ZM215.987 26.204V31.076H209.267V33.624H217.499V39H202.547V18H217.331L216.491 23.376H209.267V26.204H215.987Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.3511,
    y: 6.77612,
    width: 2.25866,
    height: 11.2933,
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.2703,
    y: 15.0579,
    width: 44.4204,
    height: 24.8453,
    rx: 7.52888,
    fill: "#6AA4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.0347,
    y: 18.0693,
    width: 36.8915,
    height: 18.4458,
    rx: 5.64666,
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 28.7978C71 26.199 73.1067 24.0923 75.7055 24.0923H75.7911C76.0557 24.0923 76.2702 24.3068 76.2702 24.5714V33.0243C76.2702 33.2889 76.0557 33.5034 75.7911 33.5034H75.7055C73.1067 33.5034 71 31.3966 71 28.7978Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.75 28.4214C125.75 31.0202 123.643 33.127 121.044 33.127L120.959 33.127C120.694 33.127 120.48 32.9124 120.48 32.6478L120.48 24.195C120.48 23.9304 120.694 23.7159 120.959 23.7159L121.044 23.7159C123.643 23.7159 125.75 25.8226 125.75 28.4214Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.4804,
    cy: 3.76444,
    r: 3.76444,
    fill: "#FF9292"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.1986,
    cy: 25.598,
    r: 3.01155,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.139,
    cy: 25.598,
    r: 3.01155,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_29806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ce7b36d595757445440af2fd09fc2e06.svg";
export { ForwardRef as ReactComponent };